
<template>
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5918 1L8.04653 2.45479L6.5918 3.90959" stroke="#727D94" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1.5 4.63913V3.91176C1.5 3.52594 1.65327 3.15593 1.92608 2.88311C2.1989 2.6103 2.56891 2.45703 2.95473 2.45703H8.0463" stroke="#727D94" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.95473 9.00138L1.5 7.54659L2.95473 6.0918" stroke="#727D94" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.0463 5.36523V6.0926C8.0463 6.47842 7.89303 6.84844 7.62021 7.12125C7.3474 7.39407 6.97738 7.54733 6.59156 7.54733H1.5" stroke="#727D94" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>